import { GiTrophyCup } from "react-icons/gi"
import { IoClose } from "react-icons/io5"
import { MdMessage } from "react-icons/md"

type TypeError = | 'error' | 'problem' | 'success' | 'alert'
interface Props {
  type: TypeError
  title?: string
  message: string
  clouse: () => { payload: undefined; type: string; }
}
const Message = ({ message, type, clouse, title }: Props) => {

  const showMessage = ():String => {
    let defaultMessage = "Default Message"
    defaultMessage = type === "error" ? 'Oops, an error occurred': defaultMessage
    defaultMessage = type === "success" ? 'The action was carried out satisfactorily': defaultMessage
    return defaultMessage
  }
  return (
    <div className={`c-message c-message--${type}`}>
      <div className="c-message__content">
        <span className="c-message__icon">
          {
            type === 'error' && <MdMessage />
          }
          {
            type === 'success' && <GiTrophyCup />
          }
        </span>
        <div className="c-message__box-text">
          <span className="c-message__title">
            {
              title ? title : showMessage()
            }
          </span>
          <span className="c-message__description">
            {message}
          </span>
        </div>
      </div>
      <span className="c-message__clouse" onClick={clouse}><IoClose /></span>
    </div>
  )
}

export default Message